import React from 'react';
import GameItem from '../../../GameItem';
import { initialUpperCase } from '@/pages/opinion/utils';
// 需要加头部排序：src/pages/opinion/components/TableComponents/SortBy/index.tsx
import BubbleCommon, {
  gameListMentionsTips,
  commonSentimentTips,
} from '@/pages/opinion/components/BubbleCommon';
import HoverSortCommon from '../../../HoverSortCommon';
import PercentageItemCommon from '../../../PercentageItemCommon';
import { handleGameClick } from '@/pages/opinion/utils/game';
import { Bubble } from 'tea-component';
import { transformGenreGame } from '../../../FilterCommon/utils/storage';
import { getLocale } from 'umi';
import { DBO_V } from '@op/utils/format';

export type keys =
  | 'rank'
  | 'game'
  | 'platform'
  | 'mentions'
  | 'sentiment'
  | 'emerging_keywords'
  | 'action';

export const columns = ({
  formatMessage,
  pageInfo = {},
  sort,
  setSort,
  history,
  dispatch,
}: any) => {
  const lang = getLocale();
  const transformGenreFunc = transformGenreGame(lang);

  return {
    rank: {
      key: 'rank',
      header: formatMessage({ id: 'Rank' }),
      width: 70,
      align: 'left',
      fixed: 'left',
      render: (cvm: any, rowKey: any, index: number) => {
        const { pageIndex = 1, pageSize = 8 } = pageInfo;
        return (pageIndex - 1) * pageSize + index + 1;
      },
    },
    game: {
      key: 'app_id',
      header: formatMessage({ id: 'Game' }),
      width: 200,
      align: 'left',
      fixed: 'left',
      render: (cvm: any) => {
        return (
          <div className="dbo-gamebox">
            <GameItem
              gameInfo={cvm}
              handleGameClick={() =>
                handleGameClick(cvm, dispatch, history, true)
              }
            />
          </div>
        );
      },
    },
    platform: {
      key: 'Platform',
      header: formatMessage({ id: 'Platform' }),
      width: 80,
      align: 'left',
      render: (cvm: any) =>
        formatMessage({
          id:
            cvm.entity_type === 'pc' ? 'PC' : initialUpperCase(cvm.entity_type),
        }),
    },
    genre: {
      key: 'Genre',
      header: formatMessage({ id: 'Genre' }),
      width: 150,
      align: 'left',
      render: (cvm: any) => {
        const { genre, sub_genre } = cvm;
        return (
          <Bubble
            dark
            closeOnScroll
            placement="top"
            content={
              <div>
                {genre && (
                  <p>
                    {formatMessage({ id: 'Main' })}：{transformGenreFunc(genre)}
                  </p>
                )}
                {sub_genre && (
                  <p>
                    {formatMessage({ id: 'Sub' })}：
                    {transformGenreFunc(sub_genre)}
                  </p>
                )}
              </div>
            }
          >
            <div>
              {genre && (
                <span className="genre-text-info">
                  {formatMessage({ id: 'Main' })}：{transformGenreFunc(genre)}
                </span>
              )}
              {sub_genre && (
                <span className="genre-text-info">
                  {formatMessage({ id: 'Sub' })}：
                  {transformGenreFunc(sub_genre)}
                </span>
              )}
            </div>
          </Bubble>
        );
      },
    },
    mentions: {
      key: 'Mentions',
      width: 130,
      align: 'right',
      header: (
        <HoverSortCommon
          sort={sort}
          sortOptions={[
            {
              text: formatMessage({ id: 'Sort by Mentions' }),
              value: 'mention',
            },
            {
              text: formatMessage({ id: 'Sort by Mentions DoD' }),
              value: 'mention_than',
            },
          ]}
          sortChange={(sort: { by: string; order: 'asc' | 'desc' }) => {
            setSort(sort);
          }}
        >
          {formatMessage({ id: 'Mentions' })}
          <BubbleCommon
            placement="top"
            tipsMap={gameListMentionsTips}
          ></BubbleCommon>
        </HoverSortCommon>
      ),
      render: (cvm: any) => {
        const { mention, mention_than } = cvm;
        return (
          <>
            <PercentageItemCommon
              percentage={mention_than}
              value={mention}
            ></PercentageItemCommon>
          </>
        );
      },
    },
    sentiment: {
      key: 'Sentiment',
      width: 130,
      align: 'right',
      header: (
        <HoverSortCommon
          sort={sort}
          sortOptions={[
            {
              text: formatMessage({ id: 'Sort by Sentiment' }),
              value: 'avg_sentiment',
            },
            {
              text: formatMessage({ id: 'Sort by Sentiment DoD' }),
              value: 'avg_sentiment_than',
            },
          ]}
          sortChange={(sort: { by: string; order: 'asc' | 'desc' }) =>
            setSort(sort)
          }
        >
          <BubbleCommon
            placement="top"
            tipsMap={commonSentimentTips}
            showIcon={false}
          >
            {formatMessage({ id: 'Sentiment' })}
          </BubbleCommon>
        </HoverSortCommon>
      ),
      render: (cvm: any) => {
        const { avg_sentiment, avg_sentiment_than } = cvm;
        return (
          <PercentageItemCommon
            percentage={avg_sentiment_than}
            value={avg_sentiment}
            format={DBO_V.sentiment}
          ></PercentageItemCommon>
        );
      },
    },
    emerging_keywords: {
      width: 200,
      key: 'emerging_keyWords',
      // header: (
      //   <div className="dbo-table-header-flex">
      //     <BubbleCommon showIcon={false} tipsMap={gameListKeywordTips}>
      //       {formatMessage({ id: 'Emerging Keywords' })}
      //     </BubbleCommon>
      //   </div>
      // ),
      // align: 'right',
      // render: (cvm: any) => {
      //   return (
      //     <div className="table-flex">
      //       {cvm.topics?.map((e: any, index: any) => {
      //         return <Keyword stabled key={index} data={e} />;
      //       })}
      //     </div>
      //   );
      // },
    },
    action: {
      key: 'Action',
      header: formatMessage({ id: 'Action' }),
      width: 100,
      align: 'left',
      render: (cvm: any) => {
        return (
          <a onClick={() => handleGameClick(cvm, dispatch, history, true)}>
            {formatMessage({ id: 'Details' })}
          </a>
        );
      },
    },
  };
};
